import {Action} from "@ngrx/store";

export const LOAD_ECOMMERCE_ORDERS: string = '[ecommerce orders] Load Ecommerce Orders';
export const LOAD_ECOMMERCE_ORDERS_SUCCESS: string = '[ecommerce orders] Load Ecommerce Orders Success';
export const LOAD_ECOMMERCE_ORDERS_FAIL: string = '[ecommerce orders] Load Ecommerce Orders Fail';

export const LOAD_ECOMMERCE_ORDER: string = '[ecommerce order] Load Ecommerce Order';
export const LOAD_ECOMMERCE_ORDER_SUCCESS: string = '[ecommerce order] Load Ecommerce Order Success';
export const LOAD_ECOMMERCE_ORDER_FAIL: string = '[ecommerce order] Load Ecommerce Order Fail';

export class LoadEcommerceOrders implements Action {
  readonly type: string = LOAD_ECOMMERCE_ORDERS;

  constructor(public payload: { websiteId: number, search?: string}) {
  }
}

export class LoadEcommerceOrdersSuccess implements Action {

  readonly type: string = LOAD_ECOMMERCE_ORDERS_SUCCESS;

  constructor(public payload: {
    websiteId: number,
    entities: any,
    ordersCount: number
  }) {
  }

}

export class LoadEcommerceOrdersFails implements Action {

  readonly type: string = LOAD_ECOMMERCE_ORDERS_FAIL;

  constructor(public payload: any) {
  }

}

export class LoadEcommerceOrder implements Action {
  readonly type: string = LOAD_ECOMMERCE_ORDER;

  constructor(public payload: { websiteId: number, id: number}) {
  }
}

export class LoadEcommerceOrderSuccess implements Action {

  readonly type: string = LOAD_ECOMMERCE_ORDER_SUCCESS;

  constructor(public payload: {
    websiteId: number,
    entities: any,
  }) {
  }

}

export class LoadEcommerceOrderFails implements Action {

  readonly type: string = LOAD_ECOMMERCE_ORDER_FAIL;

  constructor(public payload: any) {
  }

}

export type EcommerceOrdersAction = LoadEcommerceOrders | LoadEcommerceOrdersSuccess | LoadEcommerceOrdersFails |
  LoadEcommerceOrder | LoadEcommerceOrderSuccess | LoadEcommerceOrderFails;
